class BsSpanInfoModal extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      modalContent: ".bs-span-info-modal",
      openBtn: "[data-open-span-info]"
    };
  }

  connectedCallback() {
    this.domNodes = queryDomNodes(this.selectors, this);
    const { modalContent } = this.domNodes;
    if (modalContent && modalContent.innerHTML) {
      this.modalContent = modalContent.innerHTML;
      this.init();
    }
  }

  init() {
    this.modal = new MinimogTheme.Modal();

    addEventDelegate({
      selector: this.selectors.openBtn,
      handler: (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (this.modalContent) {
          const contentElement = document.createElement("DIV");
          contentElement.classList.add("bs-span-info-content");
          contentElement.innerHTML = this.modalContent;

          this.modal.appendChild(contentElement);
          this.modal.setSizes("bs-span-info-modal");
          this.modal.open();
        }
      }
    });
  }
}

customElements.define("bs-span-info-modal", BsSpanInfoModal);
